import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  chipsContainer: {
    position: 'absolute',
    left: '50px',
    bottom: '-7px',
  },
}));
